import 'slick-carousel';

export default {
  init() {
  },
}


// WEBPACK FOOTER //
// ./scripts/htheme/pagebuilder/components/slider.js